export const sourceOptions = [
    'website',
    'event',
    'personal contact',
    'referral',
    'linkedin',
    'conference',
    'facebook',
    'instagram',
    'twitter',
    'other',
]

export const provinceOptions = [
    {name: 'Alberta', value: 'AB'},
    {name: 'British Columbia', value: 'BC'},
    {name: 'Manitoba', value: 'MB'},
    {name: 'New Brunswick', value: 'NB'},
    {name: 'Newfoundland and Labrador', value: 'NL'},
    {name: 'Nova Scotia', value: 'NS'},
    {name: 'Ontario', value: 'ON'},
    {name: 'Prince Edward Island', value: 'PE'},
    {name: 'Quebec', value: 'QC'},
    {name: 'Saskatchewan', value: 'SK'},
    {name: 'Northwest Territories', value: 'NT'},
    {name: 'Nunavut', value: 'NU'},
    {name: 'Yukon', value: 'YT'},
]